import {Autocomplete} from "@material-ui/lab";
import {CircularProgress, TextField} from "@material-ui/core";
import './AutcompleteWithoutIcon.css';
import {withStyles} from "@material-ui/core/styles";
import AutocompleteChip from "./autocomplete-chip/AutocompleteChip";
import PropTypes from "prop-types";

const AutocompleteTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            color: "#757575",
            '& fieldset': {
                borderColor: 'transparent',
            },
            '&:hover input': {
                cursor: 'pointer'
            },
            '&:hover fieldset': {
                borderColor: '#fff'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#ccc'
            }
        }
    }
})(TextField);

const AutocompleteWithoutIcon = (props) => {
    const handleOnChangeItems = (event, values) => {
        event.preventDefault();
        props.setSelectedItems(values);
    }

    return <Autocomplete
        multiple
        options={props.allItems}
        getOptionLabel={(option) => option.label}
        getOptionSelected={(option, value) => option.id === value.id}
        value={props.selectedItems}
        onChange={(event, value) => handleOnChangeItems(event, value)}
        size={"small"}
        disableClearable
        debug
        filterSelectedOptions
        renderOption={(option) => (
            <AutocompleteChip size={"small"}
                              label={option.label}
                              style={{backgroundColor: props.bgColor, color: props.txtColor}}/>
        )}
        renderInput={(params) => (
            <AutocompleteTextField
                {...params}
                placeholder={props.selectedItems.length === 0 ? props.placeholder : ""}
                variant="outlined"
                value={props.searchText}
                onChange={props.setSearchText}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <>
                            {props.loading ? <CircularProgress color="primary"
                                                               size={25}/> : null}
                            {params.InputProps.endAdornment}
                        </>
                    ),
                }}
            />
        )}
        renderTags={(tagValue, getTagProps) => (
            tagValue.map((option, index) => (
                    <AutocompleteChip
                        label={option.label}
                        size={"small"}
                        style={{backgroundColor: props.bgColor, color: props.txtColor}}
                        {...getTagProps({index})}
                    />
                )
            )
        )
        }
    />
}

AutocompleteWithoutIcon.propTypes = {
    allItems: PropTypes.array.isRequired,
    selectedItems: PropTypes.array.isRequired,
    setSelectedItems: PropTypes.func.isRequired,
    searchText: PropTypes.string.isRequired,
    setSearchText: PropTypes.func.isRequired,
    loading: PropTypes.bool
}

AutocompleteWithoutIcon.defaultProps = {
    loading: false,
    bgColor: "#4fc0e8",
    txtColor: "#fff"
}

export default AutocompleteWithoutIcon;
